type VisibleTime<TimeNames extends string> = {
    [TimeName in TimeNames as `visible${Capitalize<TimeName & string>}`]: number;
};

type StreamTime<TimeNames extends string> = {
    [TimeName in TimeNames as `stream${Capitalize<TimeName & string>}`]: number;
};

export type GenericTime<TimeNames extends string> = VisibleTime<TimeNames> & StreamTime<TimeNames>;

/** @see OTT-82541 if need hide preroll timeline */
export class Time implements GenericTime<'time'> {
    public visibleTime: number;

    constructor(public streamTime: number, prerollDuration: number = 0) {
        this.visibleTime = this.streamTime - prerollDuration;
    }
}
